<template>
  <div class="w-full">
    <div class="table-parent w-full">
      <div class="table">
        <div class="table-responsive">
          <table v-if="data.total" class="table border-collapse text-left">
            <thead class="flex w-full">
            <slot name="thead"></slot>
            </thead>
            <tbody class="flex flex-col items-center justify-between overflow-y-scroll w-full"
                   :class="{'h-60-screen': data.total > 10}">
            <slot name="tbody" :items="data.data"></slot>
            </tbody>
          </table>
          <div v-else class="no-records">
            There are no records.
          </div>
          <!-- <vs-alert v-else class="w-full" color="danger" title="Danger" active="true">
            There are no records.
          </vs-alert> -->
        </div>
      </div>
    </div>

    <div v-if="data.total > 10">
      <pagination :data="data" :limit="1" @pagination-change-page="paginationChanged"></pagination>

      <div class="show-rows-parent">
        <div class="v-selet-parent">
          <v-select :options="pageCounts" label="name" class="pagination-selector w-full" v-model="itemsPerPage"></v-select>
        </div>

        <div class="v-select-title">
          <span class="show-rows">Show Rows</span>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  name: 'speakol-table',
  data () {
    return {
      pageCounts: [10, 25, 50, 100],
      itemsPerPage: 10
    }
  },
  watch: {
    itemsPerPage (val) {
      this.$emit('items-per-page-changed', val)
    }
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  methods: {
    paginationChanged (page) {
      this.$emit('pagination-change-page', page)
    }
  }
}
</script>

<style lang="scss" scoped>
.h-60-screen {
  max-height: 100vh;
}
// header background
.tbl-header-background {
  background-color: rgba(0, 146, 215, 0.06);
}
// content background
.tbl-content-background {
  background: rgba(0, 146, 215, 0.03);
}
// table scroll x
.table-responsive {
  // max-width: 1156px;
  overflow-x: auto;
}

table,
.table {
  width: 100% !important;
}

.table-parent {
  // height:auto;
  overflow-x: auto;
  margin-right: 13px;
}
// customize scrolling
.table-responsive::-webkit-scrollbar-track {
  border-radius: 10px !important;
  background-color: #f5f5f5 !important;
}

.table-responsive::-webkit-scrollbar {
  height: 6px !important;
  background-color: #f5f5f5 !important;
}

.table-responsive::-webkit-scrollbar-thumb {
  border-radius: 10px !important;
  background-color: lightgrey !important;
}
// pagination
.pagination {
  float: right;
  display: flex;
  margin-top: 10px;
  padding: 5px 5px 5px 5px;
  background-color: rgba(57, 176, 222, 0.106261);
  border-radius: 50px;

  /deep/ a {
    color: black;
  }

  /deep/ li {
    margin-right: 10px;
    margin-left: 10px;
  }

  /deep/ .active {
    cursor: pointer;
    background-color: #4492e7;
    border-radius: 100%;
    padding: 1px 9px;

    /deep/ a {
      color: white;
    }
  }
}
// count rows v-select
.v-selet-parent {
  float: right;
  display: flex;
  margin-top: 10px;
  margin-right: 20px;

  /deep/ .vs__clear {
    display: none;
  }

  /deep/ .vs__dropdown-toggle {
    border-radius: 100px;
    border: 1px solid #d9d9d9;
    padding: 0;
  }

  /deep/ .vs__actions {
    padding: 0 6px 0 12px;
  }

  /deep/ .vs--single .vs__selected {
    margin-top: 0;
  }
}
// count rows title
.v-select-title {
  float: right;
  margin-top: 17px;
  margin-right: 10px;
}
// medium screens
@media (min-width: 1450px) {
  .table-responsive {
    // max-width: 1556px;
    // overflow-x: auto
  }
}
// mobile version
@media (max-width: 768px) {
  .table-responsive {
    max-width: 390px;
    overflow-x: auto;
  }

  .pagination {
    float: none;
    margin-bottom: 10px;
  }

  .v-selet-parent {
    margin-right: 70px;
  }
}

.no-records {
  text-align: center;
  color: rgba(0, 0, 0, 0.56);
  font-weight: normal;
  font-size: 18px;
}
</style>
